<template lang="pug">
  tr(v-if="extraField.name !== 'donation_target'")
    td.py-2.pr-1.pl-3
      div.p2.primary--text.handle {{ extraField.name }}
    td.px-1
      v-row(no-gutters justify="center")
        v-col.shrink
          y-checkbox.mb-n2(v-model="extraField.enabled" hide-details)
    td.px-1
      v-row(no-gutters justify="center")
        v-col.shrink
          y-checkbox.mb-n2(v-model="extraField.required" hide-details)
    td.px-0
      div.d-flex.align-center.justify-center
        v-btn(icon @click="openDeleteDialog = !openDeleteDialog" small)
          v-icon(color="red") mdi-delete-outline
        v-btn.ml-1(icon @click="showEditDialog = !showEditDialog" small)
          v-icon mdi-square-edit-outline

    .modals
      add-wa-extra-field(v-if="showEditDialog" :open.sync="showEditDialog" :field.sync="extraField" @added="handleFieldAdded" :settings.sync="settings")
      y-dialog(v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('remove_field') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('remove_field_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='removeField()')
              .button-AA-small.basic100--text {{ $t('remove') }}

</template>

<script>
import AddWaExtraField from '@/components/dialogs/AddWaExtraField.vue'

export default {
  name: 'ExtraFormField',
  props: ['field', 'index', 'settings'],
  components: { AddWaExtraField },
  data: () => ({
    openDeleteDialog: false,
    showEditDialog: false
  }),
  computed: {
    extraField: {
      get() {
        return this.field
      },
      set(newValue) {
        this.$emit('update:field', newValue)
      }
    }
  },
  methods: {
    removeField () {
      this.$emit('deleted', this.index)
      this.openDeleteDialog = false
    },
    handleFieldAdded(field) {
      // this.field = field
      this.extraField = field
      this.$emit('edited', field, this.index)
    }
  }
}
</script>

<style scoped>
  tr:first-child td {
    border-top: thin solid rgba(0, 0, 0, 0.12);
  }
</style>

<i18n>
{
  "en": {
    "remove_field_confirmation": "Are you sure you want to remove this field? This action is irreversible."
  },
  "id": {
    "remove_field_confirmation": "Anda yakin ingin menghapus bidang ini? Bidang ini akan dihapus secara permanen."
  }
}
</i18n>